<template>
  <div class="form-group">
    <b-form-group class="form-control form-control-lg text-center no-border" id="sel3">
      <b-form-radio-group v-model="question.GivenAnswer"
                          plain
                          class="w-100 d-flex justify-content-around p-t-20">
        <b-form-radio v-for="idx in [1,2,3,4,5]"
                      :key="idx"
                      class="material-icons"
                      :value="idx">
          <component :is="iconName[idx]"
                     class="icon"
                     :class="{ selected: question.GivenAnswer === idx }"
                     decorative>
          </component>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
  import EmoticonDeadIcon from "vue-material-design-icons/EmoticonDead"
  import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad"
  import EmoticonNeutralIcon from "vue-material-design-icons/EmoticonNeutral"
  import EmoticonHappyIcon from "vue-material-design-icons/EmoticonHappy"
  import EmoticonExcitedIcon from "vue-material-design-icons/EmoticonExcited"

  export default {
    props: {
      question: {
        required: true,
        type: Object,
      },
    },
    components: {EmoticonDeadIcon, EmoticonSadIcon, EmoticonNeutralIcon, EmoticonHappyIcon, EmoticonExcitedIcon},
    data () {
      return {
        iconName: ['','emoticon-dead-icon','emoticon-sad-icon','emoticon-neutral-icon','emoticon-happy-icon','emoticon-excited-icon']
      }
    },
  }
</script>

<style scoped>
  .icon {
    color: lightblue;
    transform: scale(2) translateX(-5px);
  }

  .selected {
    color: darkblue;
    transform: scale(2.5) translateX(-5px);
  }
</style>



// WEBPACK FOOTER //
// src/components/surveys/types/Smileys.vue